var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('iframe',{attrs:{"id":"iframe_zjw","src":_vm.url,"frameborder":"0","width":"100%","height":"100%"}}),_c('download-qr-code')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }